import React, { useEffect } from 'react'
import useApp from 'hooks/useApp'
import { Button } from 'components'

const MyInfoResign = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding">
				<h3>탈퇴하는 이유가 무엇인가요?</h3>

				<ul className="resign-list mt_40">
					<li>
						<div className="chk">
							<input type="radio" id="radio1" name="resign" />
							<label htmlFor="radio1">
								<span>이미 쓰고 있는 동일한 서비스가 있어요.</span>
							</label>
						</div>
					</li>
					<li>
						<div className="chk">
							<input type="radio" id="radio2" name="resign" />
							<label htmlFor="radio2">
								<span>이용이 불편하고 장애가 많아요.</span>
							</label>
						</div>
					</li>
					<li>
						<div className="chk">
							<input type="radio" id="radio3" name="resign" />
							<label htmlFor="radio3">
								<span>사용빈도가 낮아요.</span>
							</label>
						</div>
					</li>
					<li>
						<div className="chk">
							<input type="radio" id="radio4" name="resign" />
							<label htmlFor="radio4">
								<span>탈퇴하고 다시 가입할래요.</span>
							</label>
						</div>
					</li>
					<li>
						<div className="chk">
							<input type="radio" id="radio5" name="resign" />
							<label htmlFor="radio5">
								<span>앱을 어떻게 쓰는지 모르겠어요.</span>
							</label>
						</div>
					</li>
					<li>
						<div className="chk">
							<input type="radio" id="radio6" name="resign" />
							<label htmlFor="radio6">
								<span>기타</span>
							</label>
						</div>
					</li>
				</ul>
				<textarea placeholder="모니가 성장하도록 의견을 남겨주세요." className="write-area mt_10" style={{ minHeight: "8rem" }} />
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big">다음</Button>
			</div>
		</div>
	)
}

export default MyInfoResign
